import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms'; 
import { OptionsserviceService, UserService, LoansService, AuthenticationService, StorageService, DataService } from '../../_services/index';
import { User } from '../../_models/index';
import { IonRangeSliderComponent } from "ng2-ion-range-slider";
import { Router } from '@angular/router';

@Component({
  selector: 'app-investmentdashboard',
  templateUrl: './investmentdashboard.component.html',
  styleUrls: ['./investmentdashboard.component.css',
  './style.css',
  './boot-outline-btn.css']
})
export class InvestmentdashboardComponent implements OnInit {
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  loadingRouteConfig = false;
  public searchView = false;
  public loading = true;
  public currentUser: any;
  public investments: any;
  loans = [];
  otherClosed = true;
  secOpen = '0';
  miniSearch = false;
  public durations = [
    { display: '0 - 1', checked: false, min: 0, max: 30 },
    { display: '0 - 3', checked: false, min: 31, max: 90 },
    { display: '4 - 6', checked: false, min: 91, max: 180 },
    { display: '7 - 12', checked: false, min: 181, max: 365 },
    { display: '1+ Years', checked: false, min: 366, max: 3650 }
  ];
  public statuses = [
    { value: '0', display: '' },
    { value: '1', display: 'Active' },
    { value: '2', display: 'Closed' }
  ];
  searchText = '';
  magic_filter = { reset:false,start:0,funding: '100', token: '', min: 0, max: 10000000, loan_status: this.statuses[1].value, searchText: '', ratings_one: false, ratings_two: false, ratings_three: false, ratings_four: false, ratings_five: false, funding_amount_one: 1, funding_amount_two: 1, funding_amount_three: false, funding_status_contract_created: false, funding_status_applied: false, funding_status_funded: false, funding_status: false, amount: false, approval_level: false, rating: false, sector: false, date: false };
  constructor(private dataService: DataService, private router: Router,public optionsService: OptionsserviceService, public fb: FormBuilder, public loansService: LoansService, public storageService: StorageService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    
  }

  ngOnInit() {
    this.getInvestments();
  }

  openSec(sec) {
    this.otherClosed = true;
    this.secOpen = sec;
  }
  getInvestments() {
    this.loading = true;
    this.loansService.getInvestmentsNew(this.currentUser.token, this.magic_filter) 
      .subscribe(result => {
        this.loading = false;
        this.investments = result;
        this.loans = result.loans;
        this.magic_filter.start = result.summary.start;
      });
  }
  searchForLoans(){
    this.getInvestments();
  }
  onScrollDown(ev) {
    this.loadMoreRecordsAll(this.magic_filter.start);
  }
  filteringLoans = false;
  adding_more = false;
  
  loadMoreRecordsAll(start) {
    this.filteringLoans = true;
    this.magic_filter.reset = true;
    this.magic_filter.start = start;
    // this.getLoans()
    this.searchView = false;
    this.magic_filter.token = this.currentUser.token;
    this.adding_more = true;
    this.loansService.getInvestmentsNew(this.currentUser.token, this.magic_filter) 
      .subscribe(result => {
        this.loading = false;
        //this.investments.loans.push(result.loans);
        this.adding_more = false;
         this.magic_filter.start = result.start;
         //result.loans.map(val => (this.investments.loans.push(val)));
         this.loans.push(...result.loans);
      }); 
  }
  sideview = 'master';
  loadRequest(request) { 
    this.sideview = 'placeholder';
    let url = this.router.url; 
    this.router.navigate(['./investments/details/' + request.request.INVESTMENT_ID]);
  }
}
